import styled from "styled-components";

const ButtonNext = styled.button``;
const ButtonClear = styled.button``;

export { ButtonClear, ButtonNext };
